import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

@Injectable()
export class RegisterActions {
    static REGISTER_WITH_CREDENTIALS = '[Auth-Register]: Register With Credentials'; // this is for effects later on
    static REGISTER_WITH_CREDENTIALS_SUCCESS = '[Auth-Register]: Register With Credentials success';
    static REGISTER_WITH_CREDENTIALS_ERROR = '[Auth-Register]: Register With Credentials error';

    static REGISTER_SET_PROGRESS = '[Auth-Register] Set Register Progress';

    static REGISTER_VERIFY_ACCOUNT = '[Auth-Register] Verify Account';
    static REGISTER_VERIFY_ACCOUNT_SUCCESS = '[Auth-Register] Verify Account Success';
    static REGISTER_VERIFY_ACCOUNT_ERROR = '[Auth-Register] Verify Account Error';

    registerWithCredentials(): RidangoReduxAction {
        return {
            type: RegisterActions.REGISTER_WITH_CREDENTIALS,
        };
    }

    registerWithCredentialsSuccess(payload: any): RidangoReduxAction {
        return {
            type: RegisterActions.REGISTER_WITH_CREDENTIALS_SUCCESS,
            payload: payload,
        };
    }

    registerWithCredentialsError(payload: any): RidangoReduxAction {
        return {
            type: RegisterActions.REGISTER_WITH_CREDENTIALS_ERROR,
            payload: payload,
        };
    }

    setRegisterProgress(payload: number): RidangoReduxAction {
        return {
            type: RegisterActions.REGISTER_SET_PROGRESS,
            payload: payload,
        };
    }

    verifyAccount(): RidangoReduxAction {
        return {
            type: RegisterActions.REGISTER_VERIFY_ACCOUNT,
        };
    }

    verifyAccountSuccess(accessToken: string): RidangoReduxAction {
        return {
            type: RegisterActions.REGISTER_VERIFY_ACCOUNT_SUCCESS,
            payload: accessToken,
        };
    }

    verifyAccountError(error: any): RidangoReduxAction {
        return {
            type: RegisterActions.REGISTER_VERIFY_ACCOUNT_ERROR,
            payload: error,
        };
    }
}
